import { SSOConfig } from "../models/sso-config-interface";

// XML processing function
export const processParsedXml = (content: string): SSOConfig | null => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/xml');
    return mapXmlDocumentToSsoConfiguration(doc);
  } catch (error) {
    console.error('Error parsing XML:', error);
    return null;
  }
};

// XML mapping function
export const mapXmlDocumentToSsoConfiguration = (doc: Document): SSOConfig | null => {
  const documentEntityId = doc.querySelector('EntityDescriptor')?.getAttribute('entityID');
  const documentSignOnUrl = doc.querySelector('SingleSignOnService')?.getAttribute('Location');
  const documentCertificate = doc.querySelector('X509Certificate')?.textContent;

  if (!documentEntityId && !documentSignOnUrl && !documentCertificate) {
    return null;
  }

  return {
    entityId: documentEntityId ?? '',
    signOnUrl: documentSignOnUrl ?? '',
    certificate: documentCertificate ?? ''
  } as SSOConfig;
};
